
import { Component, Prop, Vue } from 'bits/vue'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'

@Component({ components: { OzBaseButton } })
export default class OzToggle extends Vue {
  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Value of switch.
   * @default false
   */
  @Prop({ default: false }) value!: boolean

  /**
   * Determines if the switch is disabled.
   * @default false
   */
  @Prop({ default: false }) disabled!: boolean

  change(): void {
    if (this.disabled) return
    this.$emit('input', this.value)
  }
}
